import { FEATURE_FLAGS_NAMES } from "@silverfort-nodelibs/common/utils/consts"
import { isFeatureActive } from "@silverfort-nodelibs/common/utils/common"

import useFeature from "../../SystemSettings/hooks/featureFlags/useFeature"

export const AccordingToTooltip = () => {
    const accordingToIpFF = useFeature(FEATURE_FLAGS_NAMES.AccordingToIp)
    const accordingToIpFFEnabled = isFeatureActive(accordingToIpFF);
    if (!accordingToIpFFEnabled) {
        return (
            <div>
                <ul>
                    <li>
                        <span>User only - </span> User will be prompted for MFA, according to
                        the selected frequency, regardless of the device or resource being
                        accessed.
                    </li>
                    <li>
                        <span>Source (default) - </span> User will be prompted for MFA for each
                        new source being accessed.
                    </li>
                    <li>
                        <span>Destination - </span> User will be prompted for MFA for each new
                        destination being accessed.
                    </li>
                    <li>
                        <span>Specific TGT - </span> User will be prompted for MFA for each new
                        TGT (Kerberos only).
                    </li>
                    <li>
                        <span>Risk Level - </span> User will be prompted for MFA if the risk
                        level increases.
                    </li>
                </ul>
            </div>
        )
    }
    return (
        <div>
            <ul>
                <li>
                    <span>User only - </span> User will be prompted for MFA, according to
                    the selected frequency, regardless of the device or resource being
                    accessed.
                </li>
                <li>
                    <span>Source - Hostname (default) - </span> User will be prompted for
                    MFA for each new source (hostname) being accessed.
                </li>
                <li>
                    <span>Source - IP - </span> User will be prompted for MFA for each new
                    source (IP) being accessed. Supported for Kerberos and Entra ID policies only.
                </li>
                <li>
                    <span>Destination - </span> User will be prompted for MFA for each new
                    destination being accessed.
                </li>
                <li>
                    <span>Specific TGT - </span> User will be prompted for MFA for each new
                    TGT (Kerberos only).
                </li>
                <li>
                    <span>Risk Level - </span> User will be prompted for MFA if the risk
                    level increases.
                </li>
            </ul>
        </div>
    )

}